import instance from '@/utils/axios';

/**
 * 运维信息
 * @param {{deviceName: string}} data
 */
export function getMaintenanceList(data) {
  return instance.post('airDefense/deviceRunstate/findList', data);
}

/**
 * 获取通风和滤毒设备
 * @param {*} data
 * @returns
 */
export function externalDeviceListAllServer(data = {}) {
  return instance.post('airDefense/externalDevice/findAllList', data);
}

/**
 * 更新 获取通风和滤毒设备
 * @param {*} data
 * @returns
 */
export function updateExternalDeviceServer(data) {
  return instance.post('airDefense/externalDevice/update', data);
}

/*
 * 获取设备列表
 * @param {{name: string}} params
 * @returns
 */
export function getDeviceList(params) {
  return instance.get('/device/getDeviceList', { params });
}

/**
 * 获取通风和滤毒设备
 * @returns {Promise} API响应
 */
export function getExternalDeviceList() {
  return instance.post('/airDefense/externalDevice/findAllList');
}

/**
 * 更新外部设备状态
 * @param {{id: string; switchState: 0|1}} data - 设备状态更新数据
 * @returns {Promise} API响应
 */
export function updateExternalDeviceStatus(data) {
  return instance.post('/airDefense/externalDevice/update', data);
}
